import { useTranslation } from 'react-i18next';
import logoManagementRU from '#/shared/assets/logos/r7-management_RU.svg';
import logoManagementEN from '#/shared/assets/logos/r7-management_EN.svg';

export const ManagementLogo = () => {
  const { i18n, t } = useTranslation();

  const currentLanguage = i18n.language;
  const logoAdmin = currentLanguage === 'ru' ? logoManagementRU : logoManagementEN;

  return <img src={logoAdmin} alt={t('managementLogoAlt')} height={30} />;
};
